// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nh5[data-v-d04d3de6] {\n\tfont-size: 1rem;\n\tfont-weight: 600;\n\tcolor: #4D5C77;\n}\nh6[data-v-d04d3de6] {\n\tfont-size: 0.9rem;\n\tcolor: #4D5C77;\n}\n\n", ""]);
// Exports
module.exports = exports;
